import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CONTACT_TOPICS } from "../../data/contact";
import { trackEvent } from "../../lib/api";

export const TopicPicker = ({ value, onChange }) => (
  <div role="radiogroup" aria-label="Kies een onderwerp" className="grid gap-3 sm:grid-cols-2" data-testid="contact-topics">
    {CONTACT_TOPICS.map(({ id, icon: Icon, label, hint }) => {
      const on = value === id;
      return (
        <button key={id} type="button" role="radio" aria-checked={on} onClick={() => onChange(id)} data-testid={`contact-topic-${id}`}
          className={`flex items-start gap-3 rounded-2xl border p-4 text-left transition-[background-color,border-color,box-shadow] duration-200 ${on ? "border-maas bg-maas-soft/60 shadow-[0_0_0_3px_rgba(14,119,125,0.12)]" : "border-slate-200 bg-white hover:border-maas/50"}`}>
          <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl transition-colors ${on ? "bg-maas text-white" : "bg-slate-100 text-maas"}`}><Icon className="h-5 w-5" aria-hidden="true" /></span>
          <span className="min-w-0">
            <span className="block text-[15.5px] font-semibold leading-snug text-ink">{label}</span>
            <span className="mt-0.5 block text-[13.5px] text-slate-500">{hint}</span>
          </span>
        </button>
      );
    })}
  </div>
);

// Verwijzing naar een bestaande module (prijsindicatie, offertevergelijker, ISDE-check). Geen dubbel formulier.
export const TopicRoute = ({ topic }) => {
  const r = topic.route;
  return (
    <div className={`rounded-2xl p-6 sm:p-7 ${r.primary ? "bg-ink text-white" : "border border-maas/30 bg-maas-soft/50"}`} data-testid={`contact-route-${topic.id}`}>
      <h3 className={`text-[19px] font-semibold ${r.primary ? "text-white" : "text-ink"}`}>{topic.label}</h3>
      <p className={`mt-2 max-w-2xl text-[15px] leading-relaxed ${r.primary ? "text-slate-300" : "text-slate-700"}`}>{r.text}</p>
      <Link to={r.href} onClick={() => trackEvent(r.track, { location: "contact-topic" })} data-testid={`contact-route-${topic.id}-cta`}
        className={`mt-5 ${r.primary ? "btn-cta" : "btn-primary !min-h-[48px]"} group`}>
        {r.cta} <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </Link>
    </div>
  );
};
